// extracted by mini-css-extract-plugin
export default {"contact-info-image":"e__contact-info-image--MDMeH","contact-info-header":"e__contact-info-header--qe233"};